"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styled_components_1 = require("styled-components");
var Swiper_1 = require("mobile/ezUI/Swiper");
var css_1 = require("mobile/utils/css");
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\toverflow: hidden;\n\tbackground: white;\n"], ["\n\tposition: relative;\n\toverflow: hidden;\n\tbackground: white;\n"])));
var DotsWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 100%;\n\ttext-align: center;\n\tposition: absolute;\n\tbottom: 0.75rem;\n\tfont-size: 0;\n\tpointer-events: none;\n"], ["\n\twidth: 100%;\n\ttext-align: center;\n\tposition: absolute;\n\tbottom: 0.75rem;\n\tfont-size: 0;\n\tpointer-events: none;\n"])));
var Dot = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\twidth: ", ";\n\theight: ", ";\n\tbackground-color: rgba(255, 255, 255, 0.3);\n\tdisplay: inline-block;\n\tmargin-right: ", ";\n\t&:last-child {\n\t\tmargin-right: 0;\n\t}\n\t", "\n"], ["\n\twidth: ", ";\n\theight: ", ";\n\tbackground-color: rgba(255, 255, 255, 0.3);\n\tdisplay: inline-block;\n\tmargin-right: ", ";\n\t&:last-child {\n\t\tmargin-right: 0;\n\t}\n\t",
    "\n"])), css_1.px2rem(14), css_1.px2rem(2), css_1.px2rem(4), function (props) {
    return props.active && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\t\tbackground-color: #ffffff;\n\t\t"], ["\n\t\t\tbackground-color: #ffffff;\n\t\t"])));
});
var BetterSwipeWithDots = (function (_super) {
    __extends(BetterSwipeWithDots, _super);
    function BetterSwipeWithDots() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            imageIndex: 0
        };
        _this.onIndexChange = function (imageIndex) {
            _this.setState({ imageIndex: imageIndex });
        };
        return _this;
    }
    BetterSwipeWithDots.prototype.render = function () {
        var _a = this.props, isAutoSwipe = _a.isAutoSwipe, children = _a.children, swipeSensitive = _a.swipeSensitive, swipeClassName = _a.swipeClassName, style = _a.style;
        var imageIndex = this.state.imageIndex;
        var childrenCount = React.Children.count(children);
        var canSwipe = React.Children.count(children) > 1;
        return (React.createElement(Container, { style: style },
            React.createElement(Swiper_1.default, __assign({ isAutoSwipe: isAutoSwipe, className: swipeClassName }, (canSwipe ? { onIndexChange: this.onIndexChange } : {}), { swipeSensitive: swipeSensitive }), this.props.children),
            canSwipe ? (React.createElement(DotsWrapper, null, new Array(childrenCount).fill(0).map(function (_, index) { return (React.createElement(Dot, { key: index, active: index === imageIndex })); }))) : null));
    };
    BetterSwipeWithDots.defaultProps = {
        showDots: true
    };
    return BetterSwipeWithDots;
}(React.PureComponent));
exports.default = BetterSwipeWithDots;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
